<!-- 批量添加设备 -->
<template>
    <el-dialog
        title="设备列表"
        :visible.sync="modalShow"
        width="825px"
        :before-close="modalClose"
    >
    <div>
        <el-button type="primary" @click="handleAddAll" size="mini">添加全部</el-button>
    </div>
    <l-table
        :list="list"
        :total="total" 
        :otherHeight="400" 
        :options="options"
        :pagination="pagination"
        :columns="columns" 
        :operates="operates"
        @handleSizeChange="handleSizeChange"
        @handleIndexChange="handleIndexChange"
        @handleSelectionChange="handleSelectionChange" >
    </l-table>
    <div style="text-align:right;">
        <el-button type="primary" @click="submit">确定并添加</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
import Service from '@/api/Service'
import lTable from '@/components/lTable/lTable'
import { base64ToHex } from '@/utils/base64ToHex'
export default {
    name: "cmpgatewaydialog",
    inject: ["reload"],
    data() {
        return {
            multipleSelection: [],

            total: 0,
            list: [],
            columns: [
                {
                    prop: 'device-model',
                    label: '型号',
                    align: 'center',
                },
                {
                    prop: 'device-serial',
                    label: '序列号',
                    align: 'center',
                },
                {
                    prop: 'device-base',
                    label: '十六进制序列号',
                    align: 'center',
                    sortable: true,
                },
               
            ], // 需要展示的列
            operates: {
                width: 200,
                fixed: 'right',
                list: []
            }, // 操作按钮组
            pagination: {
                page_num: 1,
                page_sum: 10
            }, // 分页参数
            options: {
                stripe: true, // 是否为斑马纹 table
                loading: true, // 是否添加表格loading加载动画
                highlightCurrentRow: true, // 是否支持当前行高亮显示
                mutiSelect: true // 是否支持列表项选中功能
            } // table 的参数
        };
    },
    computed: {
        ...mapGetters(['baseData']),
    },
    props: {
        modalShow: Boolean,
        addForm: Object,
        configMeterType: Array,
    },
    created() {
        this.getData();
    },
    components: { lTable },
    methods: {
        // 获取数据
        async getData() {
            let { linked_collector_id, collector_serial } = this.addForm
            let params = Object.assign({}, this.pagination, { linked_collector_id, collector_serial });
            this.options.loading = true;
            let data = await Service.upDataMeterList(params);
            this.options.loading = false;
            if(data) {
                let list = data.list == null ? [] : data.list;
                this.total = data.total;
                this.list = this.fmtData(list);
            }
			// console.log(data)
        },
        fmtData(list) {
            return list.map(v=>{
                let obj = {};
                let meterInfo = this.configMeterType.filter(v1=>{ return v1.device_model == v["device-model"]})
                obj["device-model"] = v["device-model"];
                obj["device-serial"] = v["device-serial"];
                obj['device-base'] = base64ToHex(v["device-serial"]);
                if(meterInfo.length>0) {
                    obj['devtype'] = meterInfo[0].devtype
                    obj['terminal_base_id'] = meterInfo[0].oid
                    obj['model_name'] = meterInfo[0].model_name
                }
                return obj;
            })
        },
        //   保存确认按钮
        async submit() {
            let { linked_collector_id, collector_serial } = this.addForm;
            let terminallist = this.multipleSelection.map(v=>{
                let obj = {};
                obj.deviceserial = v["device-serial"];
                obj.linked_collector_id = Number(linked_collector_id);
                obj.collector_serial = collector_serial;
                obj.terminal_base_id = v["terminal_base_id"];
                obj.devtype = v["devtype"]
                return obj
            })
            let res = await Service.addMeterList({terminallist});
            if(res) {
                this.$message({
                    type: 'success',
                    message: '添加成功',
                });
                this.getData();
                this.multipleSelection = [];
            }
        },
        // 添加全部
        async handleAddAll() {
            let { linked_collector_id, collector_serial } = this.addForm;
            let meterInfo = this.configMeterType.filter(v=>{ return "FC109R" == v.device_model})
            let obj = {};
                obj.linked_collector_id = Number(linked_collector_id);
                obj.collector_serial = collector_serial;
                if(meterInfo.length>0) {
                    obj.terminal_base_id = meterInfo[0].oid
                    obj.devtype =  meterInfo[0].devtype
                }
            let res = await Service.addMeterListAll(obj);
            if(res) {
                this.$message({
                    type: 'success',
                    message: '添加成功',
                });
                this.reload();
            }
        },
        // 切换每页显示的数量
        handleSizeChange (pagination) {
            this.pagination = pagination;
            this.getData();
        },
        // 切换页码
        handleIndexChange (pagination) {
            this.pagination = pagination;
            this.getData();
        },
        // 选中行
        handleSelectionChange (val) {
            this.multipleSelection = val;
        },
        //   关闭弹框
        modalClose() {
            // 清空表单信息
            this.multipleSelection = [];
            this.reload();
            this.$emit("update:modalShow", false);
        },
    },
};
</script>
<style lang='less' scoped>
.delete-icon{
    margin-left: 15px;
    cursor: pointer;
    i{
        font-size: 20px;
        vertical-align: middle;
    }
    &:hover{
        i{
            color:@primary-color;
        }
    }
}
.gateway-item{
    max-height: 600px;
    overflow-y: auto;
    .el-form-item{
        margin-bottom: 18px;
    }
}
</style>